var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.985 47.8972H0V24.5054C0 11.5111 10.7371 0.980469 23.985 0.980469V47.8972Z",
    fill: "#3A383B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 47.8954H26.0157V18.7627C39.2612 18.7627 50 29.2957 50 42.2908V47.8954Z",
    fill: "#3A383B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 46.9207,
    fill: "white",
    transform: "translate(0 0.974609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconDark);
export default __webpack_public_path__ + "static/media/logo-icon-dark.764088440404b67e2579e07380899857.svg";
export { ForwardRef as ReactComponent };